export const ExpoVina = ({ className = '' }) => {
  return (
    <img src='/static/expovina.png' alt='ExpoVina' className={className} width={83} />
  );
};
